import React from 'react';
import {connect} from 'react-redux';
import Header from '../../../header';
import GuidedToursListPopup from '../../../popup/components/guided-tours-list-popup';
import SupportDetailsPopup from '../../../popup/components/support-details-popup';
import Content from '../../../content';
import {getProfile} from '../../../../../actions/profileActions';
import i18n from '../../../../../i18n';
import {I18nextProvider} from 'react-i18next';


class InvitedRegisteredGrantedRedirectAllowTemplate extends React.Component {
	constructor(props){
		super(props);
		this.props.getProfile(true);
	}
	render() {
		return (
			<I18nextProvider i18n={i18n}>
				<div className="app not-ready">
					<Header msgBar={false} />
                    <GuidedToursListPopup/>
					<SupportDetailsPopup/>
					<Content>
							{/* {
							navigator.userAgent.includes("Chrome") && !localStorage.getItem('chromeExtensionUser') && navigator.userAgent.includes("Edg") === false
								?
								this.props.isChromeExtInstalled
									?
									(!localStorage.getItem('chromeExtensionUser') &&	<RedirectToGcm redirectTo="https://contacts.google.com"/>)
									:
									(!localStorage.getItem('chromeExtensionUser') && <RedirectToGcm redirectTo={`https://chrome.google.com/webstore/detail/shared-contacts-for-gmail/${CHROME_EXT_ID}?authuser=${this.props.profile.email}`}/>)
									:
								(!localStorage.getItem('chromeExtensionUser') &&	<RedirectToGcm redirectTo="https://contacts.google.com"/>)
						} */}
					</Content>
				</div>
			</I18nextProvider>
		)
	}
}

const mapStateToProps = state => ({
	language : state.languageReducer.language,
	isChromeExtInstalled: state.profileReducer.isChromeExtInstalled,
	profile : state.profileReducer.getProfile
});

const mapDispatchToProps = (dispatch) => ({
	getProfile: (boolean) => dispatch(getProfile(boolean)),
	});

export default connect(mapStateToProps, mapDispatchToProps)(InvitedRegisteredGrantedRedirectAllowTemplate);
